var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-sim-success"},[_c('div',{staticClass:"outer-wrapper"},[(this.isEsim)?_vm._t("ceSubstituteESim"):(this.isPreActivated)?_vm._t("ceSubstituteSimActive"):_vm._t("ceSubstituteSimInactive")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }